module.exports = __webpack_public_path__ + "static/ribbon-3a6b731c2d02ebd1422222c5990f69d8.png";